import { Link as RouterLink } from 'react-router-dom';

// material-ui
import { Link, Stack, Typography } from '@mui/material';

// ==============================|| MAIN LAYOUT - FOOTER ||============================== //

const Footer = () => (
  <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ p: '24px 16px 0px', mt: 'auto' }}>
    <Typography variant="caption">&copy; Sistema de Manifiestos Americanos</Typography>
    <Stack spacing={1.5} direction="row" justifyContent="space-between" alignItems="center">
      <Link component={RouterLink} to="/Inicio"  variant="caption" color="textPrimary">
        Inicio
      </Link>
      <Link
        component={RouterLink}
        to="/Documentacion"
        
        variant="caption"
        color="textPrimary"
      >
        Documentación 
      </Link>
      <Link component={RouterLink} to="/Atencion"  variant="caption" color="textPrimary">
        Soporte
      </Link>
    </Stack>
  </Stack>
);

export default Footer;
